<template>
  <div>
    <button class="btn btn-warning" @click="showNewsletterWidget">
      ich möchte über neue Kurstermine informiert werden
    </button>

    <br />
    <br />

    <!-- ionos widget -->
    <iframe
      v-if="widgetIsOpen"
      src="https://ionos-772cdfb6b.sendserver.email/hp/Fz1d1VTwkCpJvZ6qmlb3SQ/signup"
      style="
        width: 100%;
        border-width: 0px;
        background-color: #ffffff;
        height: 215px;
      "
      border="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'NewsletterAndContactButton',
  data() {
    return {
      widgetIsOpen: false,
    };
  },
  methods: {
    showNewsletterWidget() {
      this.widgetIsOpen = true;
    },
  },
};
</script>

<style scoped></style>
